import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../../services/api";
import { logout as logoutAction } from "../../store/slices/authSlice";
import { selectCurrentCompany } from "../../store/slices/authSlice";
import "./CompanyInactive.css";

const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "support@legacy72.com";
const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/legacy72/meeting";

const CompanyInactive = () => {
  const company = useSelector(selectCurrentCompany);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutApi] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();
    } catch {
      // Logout even if API fails
    }
    dispatch(logoutAction());
    navigate("/login");
  };

  return (
    <div className="ci-page">
      <div className="ci-card">
        <div className="ci-icon">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </div>

        <h1 className="ci-title">Your company is being reviewed</h1>

        {company?.name && (
          <p className="ci-company">{company.name}</p>
        )}

        <p className="ci-description">
          Thank you for registering! Your company account is currently under review
          by our team. Once approved, you'll have full access to the platform.
        </p>

        <div className="ci-contact">
          <p className="ci-contact-label">Need help or have questions?</p>

          <a href={`mailto:${SUPPORT_EMAIL}`} className="ci-email-link">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            {SUPPORT_EMAIL}
          </a>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ci-calendly-btn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            Schedule a Meeting
          </a>
        </div>

        <button className="ci-logout-btn" onClick={handleLogout}>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default CompanyInactive;
